/**
 * @description 将query参数对象解析到url的?参数中并返回
 * @param       {[string]}                 url  [不带参数的url]
 * @param       {[string]}                 data [query参数对象]
 * @return      {[string]}                      [带参数的url]
 */
const createUrlWithQuery = (url: string, data: any): string => {
  if (data == undefined) {
    return url;
  } else {
    const uriParamArray = [];
    for (const key in data) {
      const a = key + '=' + data[key];
      uriParamArray.push(a);
    }
    const uriParam = uriParamArray.join('&');
    if (uriParam) {
      if (/\?/.test(url)) {
        const newUri = url + '&' + uriParam || '';
        return newUri;
      } else {
        const newUri = url + '?' + uriParam || '';
        return newUri;
      }
    } else {
      return url;
    }
  }
};

export default createUrlWithQuery;
